/**
 * Masonry Grid with lazy loading
 * @dependencies isotope-layout
 * @dependencies lozad
 */

import $ from 'jquery'
import Isotope from 'isotope-layout'
import lozad from 'lozad'

const grids = document.querySelectorAll('.js-isotope-grid')
if (grids) {
  for (let index = 0; index < grids.length; index++) {
    const grid = grids[index];

    // General Layout
    // We init the masonry instance but we dont fire it yet
    const masonry = new Isotope( grid, {
      itemSelector: '.card',
      percentPosition: true,
      transitionDuration: 400,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer'
      },
      // initLayout: false
    })


    // Masonry on Products (Lazy Load)
    const cards = grid.querySelectorAll('.card--product, .card--use-case')
    for (const card of cards) {

      // Some preparation
      const img = card.querySelector('img')
      const ratio = img.dataset.ratio
      img.parentNode.style.paddingBottom = ratio * 100 + '%'
      masonry.layout()
    }

    // If we have filters
    const filters = document.querySelector('.js-isotope-filters')
    if (filters) {

      const onLoadFilter = filters.dataset.autoFilter

      if (onLoadFilter) {
        masonry.arrange({ filter: onLoadFilter })
        location.hash = 'filter=' + encodeURIComponent( onLoadFilter );
      } else {
        masonry.arrange({ filter: '*' })
        location.hash = 'filter=*';
      }

      const getHashFilter = function () {
        // get filter=filterName
        var matches = location.hash.match( /filter=([^&]+)/i );
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent( hashFilter );
      }

      // init Isotope
      //var $grid = $('.grid');

      // bind filter button click
      var $filterButtonGroup = $('.js-swiper-filters');
      $filterButtonGroup.on( 'click', 'button', function() {
        var filterAttr = $( this ).attr('data-filter');
        // set filter in hash
        location.hash = 'filter=' + encodeURIComponent( filterAttr );
      });

      var $filterSelectGroup = $('.js-select-filters');
      $filterSelectGroup.on( 'change', 'select', function() {
        var filtersAttr = [];
        var selects = document.querySelectorAll('.js-select-filters select');
        selects.forEach((select) => {
          filtersAttr.push(select.value);
        })

        // set filter in hash
        location.hash = 'filter=' + encodeURIComponent( filtersAttr.join('') );
      });

      var isIsotopeInit = false;

      const onHashchange = function () {
        var hashFilter = getHashFilter();
        // console.log(hashFilter);
        if ( !hashFilter && isIsotopeInit ) {
          return;
        }
        isIsotopeInit = true;

        // filter isotope
        masonry.arrange({ filter: hashFilter })
        // $grid.isotope({
        //   itemSelector: '.element-item',
        //   layoutMode: 'fitRows',
        //   // use filterFns
        //   filter: filterFns[ hashFilter ] || hashFilter
        // });
        // set selected class on button
        if ( hashFilter ) {
          $filterButtonGroup.find('.selected').removeClass('selected');
          $filterButtonGroup.find('[data-filter="' + hashFilter + '"]').addClass('selected');
        }
      }

      $(window).on( 'hashchange', onHashchange );

      // trigger event handler to init Isotope
      onHashchange();
    }
  }


  // Lazy Loading with Lozad
  const observer = lozad('.card__thumb img', {
    threshold: 0.1, // ratio of element convergence
    loaded: function (el) {
      // When Loaded
      el.closest('.card').classList.add('is-loaded');
    }
  })
  observer.observe()
}
